/* Common Imports */

import React from "react";

/* Component Imports */

import Layout from "../components/layout-components/Layout";
import SignUpForm from "../components/page-sections/sign-up/SignUpForm";

/* Session Imports */

import { withIronSessionSsr } from "iron-session/next";
import { sessionOptions } from "../lib/session";

const SignUp = ({ user }) => {
  return (
    <React.Fragment>
      <Layout user={user}>
        <SignUpForm />
      </Layout>
    </React.Fragment>
  );
};

export default SignUp;

// eslint-disable-next-line space-before-function-paren
export const getServerSideProps = withIronSessionSsr(async function ({
  req,
  res,
}) {
  /* Getting user session cookie */
  const user = await req.session.user;

  /* here we just check if user is already logged in and redirect to dashboard */

  if (user !== undefined) {
    if (user.role == "client") {
      res.setHeader("Cache-Control", "no-store");
      res.setHeader("location", "/user-dashboard");
      res.statusCode = 302;
      res.end();
    } else if (user.role == "staff") {
      res.setHeader("Cache-Control", "no-store");
      res.setHeader("location", "/user-dashboard");
      res.statusCode = 302;
      res.end();
    }
    return {
      props: {
        user: user,
      },
    };
  } else {
    return {
      props: {
        user: null,
      },
    };
  }
},
sessionOptions);
